import React from "react";
import Link from "next/link";
import BrandLogo from "./BrandLogo";
import { NIFTY_CONTRACT } from "../../utils/niftyData";

/**
 * Global footer — mission-control layout from the NiftySky design.
 * Real internal links route to existing pages; socials open externally.
 */
const COLS: { h: string; items: { label: string; href: string }[] }[] = [
  {
    h: "EXPLORE",
    items: [
      { label: "Marketplace", href: "/marketplace" },
      { label: "Planets", href: "/real-estate/categories/planets" },
      { label: "Moons", href: "/real-estate/categories/moons" },
      { label: "Roadmap", href: "/roadmap" },
    ],
  },
  {
    h: "RESOURCES",
    items: [
      { label: "FAQ", href: "/faq" },
      { label: "Bounty", href: "/bounty" },
      { label: "Token", href: "/token" },
      { label: "Team", href: "/team" },
    ],
  },
  {
    h: "LEGAL",
    items: [
      { label: "Terms", href: "/redeem" },
      { label: "Privacy", href: "/redeem" },
      { label: "Provenance", href: "/redeem" },
      { label: "Bounty", href: "/bounty" },
    ],
  },
];

const SOCIALS: { label: string; href: string }[] = [
  { label: "TWITTER", href: "https://twitter.com/NiftySkyDAO" },
  { label: "REDDIT", href: "https://www.reddit.com/r/NiftySkyDAO/" },
  { label: "TELEGRAM", href: "https://t.me/NiftySkyDao" },
  { label: "DISCORD", href: "https://discord.com/invite/v22auzmX" },
];

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="site-foot">
      <div className="wrap">
        <div className="foot-top">
          <div className="foot-brand">
            <Link href="/" className="brand" aria-label="NiftySky home">
              <BrandLogo size={34} />
              <span className="brand-name">Nifty<b>Sky</b></span>
            </Link>
            <p className="foot-tag">
              Tokenizing the final frontier — real astronomical assets on-chain,
              backed by verifiable science.
            </p>
            <div className="foot-social">
              {SOCIALS.map((s) => (
                <a
                  key={s.label}
                  className="foot-social-link"
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {s.label}
                </a>
              ))}
            </div>
          </div>
          <div className="foot-cols">
            {COLS.map((col) => (
              <div className="foot-col" key={col.h}>
                <div className="foot-h">{col.h}</div>
                {col.items.map((it, i) => (
                  <Link key={col.h + i} href={it.href}>
                    {it.label}
                  </Link>
                ))}
              </div>
            ))}
            <div className="foot-col">
              <div className="foot-h">NETWORK</div>
              <div className="foot-net mono">
                <span>
                  <span className="dot dot-live" />
                  BASE SEPOLIA
                </span>
                <span>ERC-721 · VERIFIED</span>
                <span className="foot-addr">{NIFTY_CONTRACT}</span>
              </div>
            </div>
          </div>
        </div>
        <div className="hr" />
        <div className="foot-bot mono">
          <span>© {year} NiftySky DAO · ALL SKIES RESERVED</span>
          <span>BUILT ON VERIFIABLE SCIENCE · NASA · IAU · USGS</span>
        </div>
      </div>

      {/* Oversized faint brand wordmark (Chakra Petch) anchored to the base. */}
      <div className="foot-wordmark" aria-hidden>
        NIFTY<span>SKY</span>
      </div>
    </footer>
  );
};

export default Footer;
